export const MenuItems = [
    {
        title : 'Home',
        url : '/',
        cName : 'nav-links'
    },
    {
        title : 'Men',
        url : '/men',
        cName : 'nav-links'
    },
    {
        title : 'Women',
        url : '/women',
        cName : 'nav-links'
    },
    {
        title : 'Kids',
        url : '/kids',
        cName : 'nav-links'
    },
    {
        title : 'Accessories',
        url : '/accessories',
        cName : 'nav-links'
    },
    {
        title : 'Offers',
        url : '/discount',
        cName : 'nav-links'
    },
    {
        title : 'About Us',
        url : '/about',
        cName : 'nav-links'
    },
    {
        title : 'Sign In',
        url : '/signIn',
        cName : 'nav-links-mobile'
    },
    {
        title : 'Sign Up',
        url : '/signUp',
        cName : 'nav-links-mobile'
    },
]